<div class="flex flex-column justify-content-between" style="height: 100%;">
  <form [formGroup]="formGroup">
    <!-- Tipo de programa y Nombre -->
    <div class="p-fluid formgrid mr-2 ml-2 grid"
    style="justify-content: start">
      <div class="field col-12 md:col-4">
        <label for="type" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.SelectProgramTypeText" | translate }} *</label
          >
        <p-dropdown
          id="type"
          [options]="programTypes"
          formControlName="type"
          optionValue="value"
          [showClear]="true"
          [style]="{ width: '100%' }"
          [optionLabel]="profile?.lang == 'en' ? 'nameEn' : 'nameEs'"
          placeholder="{{
            'DirectSaleFormPage.SelectProgramTypeText' | translate
          }}"
          (onChange)="onChangeImportToCountry()"
        />
        <small class="p-error block" *ngIf="formGroup.get('type')?.hasError('required') && formGroup.get('type')?.touched">
          {{ "type" | formErrorMessage : formGroup }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label for="programName" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.ProgramName" | translate }}</label
        >
        <input
          id="programName"
          type="text"
          pInputText
          formControlName="programName"
          [style]="{ width: '100%' }"
          placeholder="{{
            'DirectSaleFormPage.ProgramName' | translate
          }}"
        />
      </div>
    </div>

    <!-- Importador, Consignee y Notifier -->
    <div class="p-fluid formgrid mr-2 ml-2 grid"
      style="justify-content: start">
      <div class="field col-12 md:col-4">
        <label for="importerId" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.ImporterFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="importerId"
          [options]="importers"
          formControlName="importerId"
          optionValue="id"
          [showClear]="false"
          [filter]="true"
          filterBy="companyName"
          [style]="{ width: '100%' }"
          optionLabel="companyName"
          placeholder="{{
            'DirectSaleFormPage.ImporterFieldLabel' | translate
          }}"
          (onChange)="onChangeImporter()"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('importerId')?.hasError('required') && formGroup.get('importerId')?.touched">
          {{ "importerId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label for="consigneeId" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.ConsigneeFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="consigneeId"
          [options]="consignees"
          formControlName="consigneeId"
          optionValue="id"
          [filter]="true"
          [showClear]="false"
          [style]="{ width: '100%' }"
          optionLabel="companyName"
          filterBy="companyName"
          placeholder="{{
            'DirectSaleFormPage.ConsigneeFieldLabel' | translate
          }}"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('consigneeId')?.hasError('required') && formGroup.get('consigneeId')?.touched">
          {{ "consigneeId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label for="notifyId" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.NotifyFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="notifyId"
          [options]="notifies"
          formControlName="notifyId"
          optionValue="id"
          [showClear]="false"
          [filter]="true"
          [style]="{ width: '100%' }"
          optionLabel="companyName"
          filterBy="companyName"
          placeholder="{{
            'DirectSaleFormPage.NotifyFieldLabel' | translate
          }}"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('notifyId')?.hasError('required') && formGroup.get('notifyId')?.touched">
          {{ "notifyId" | formErrorMessage : formGroup }}
        </small>
      </div>
    </div>

    <!-- Especies, Variedad e Incoterms -->
    <div class="p-fluid formgrid mr-2 ml-2 grid" style="justify-content: space-between">
      <div class="field col-12 md:col-4">
        <label for="speciesId" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.SpeciesFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="speciesId"
          [options]="species"
          formControlName="speciesId"
          optionValue="id"
          [showClear]="true"
          [style]="{ width: '100%' }"
          optionLabel="nameEs"
          [filter]="true"
          [filterBy]="profile?.lang == 'en' ? 'name' : 'nameEs'"
          placeholder="{{
            'DirectSaleFormPage.SpeciesFieldLabel' | translate
          }}"
          (onChange)="onChangeSpecies()"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('speciesId')?.hasError('required') && formGroup.get('speciesId')?.touched">
          {{ "speciesId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label for="varietyId" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.VarietyFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="varietyId"
          [options]="varieties"
          formControlName="varietyId"
          optionValue="id"
          [filter]="true"
          [showClear]="true"
          [style]="{ width: '100%' }"
          optionLabel="name"
          placeholder="{{
            'DirectSaleFormPage.VarietyFieldLabel' | translate
          }}"
          (onChange)="onChangeVariety()"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('varietyId')?.hasError('required') && formGroup.get('varietyId')?.touched">
          {{ "varietyId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <div class="field col-12 md:col-4">
        <label for="incoterms" style="font-weight: bolder"
          >{{ "DirectSaleFormPage.IncotermsFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="incoterms"
          [options]="incotermsOptions"
          formControlName="incoterms"
          optionValue="value"
          [showClear]="true"
          [style]="{ width: '100%' }"
          optionLabel="label"
          placeholder="{{
            'DirectSaleFormPage.IncotermsFieldLabel' | translate
          }}"
          (onChange)="onChangeIncoterm($event)"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('incoterms')?.hasError('required') && formGroup.get('incoterms')?.touched">
          {{ "incoterms" | formErrorMessage : formGroup }}
        </small>
      </div>
    </div>

    <!-- País de importación, Puerto/Aeropuerto -->
    <div class="p-fluid formgrid mr-2 ml-2 grid" style="justify-content: start">
      <div class="field col-12 md:col-4">
        <label style="font-weight: bolder" for="importToCountryId"
          >{{ "DirectSaleFormPage.DestinationCountryFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="importToCountryId"
          [options]="countries"
          formControlName="importToCountryId"
          optionValue="id"
          [showClear]="true"
          [filter]="true"
          [style]="{ width: '100%' }"
          optionLabel="name"
          [filterBy]="profile?.lang == 'en' ? 'name' : 'nameEs'"
          placeholder="{{
            'DirectSaleFormPage.DestinationCountryFieldLabel' | translate
          }}"
          (onChange)="onChangeImportToCountry()"
        >
        </p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('importToCountryId')?.hasError('required') && formGroup.get('importToCountryId')?.touched">
          {{ "importToCountryId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <!-- Puerto - visible cuando type === 0 -->
      <div
        class="field col-12 md:col-4"
        *ngIf="programType === 0"
      >
        <label style="font-weight: bolder" for="portToId"
          >{{ "DirectSaleFormPage.DestinationPortFieldLabel" | translate }} *</label
        >
        <p-dropdown
          id="portToId"
          [options]="ports"
          formControlName="portToId"
          optionValue="id"
          [showClear]="true"
          [filter]="true"
          [style]="{ width: '100%' }"
          optionLabel="name"
          placeholder="{{
            'DirectSaleFormPage.DestinationPortFieldLabel' | translate
          }}"
        ></p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('portToId')?.hasError('required') && formGroup.get('portToId')?.touched">
          {{ "portToId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <!-- Aeropuerto - visible cuando type === 1 -->
      <div
        class="field col-12 md:col-4"
        *ngIf="programType === 1"
      >
        <label style="font-weight: bolder" for="airportId"
          >{{ "DirectSaleFormPage.AirportFieldLabel" | translate }}</label
        >
        <p-dropdown
          id="airportId"
          [options]="airports"
          formControlName="airportId"
          optionValue="id"
          [showClear]="true"
          [style]="{ width: '100%' }"
          filterBy="name"
          optionLabel="name"
          [filter]="true"
          placeholder="{{
            'DirectSaleFormPage.AirportFieldLabel' | translate
          }}"
        ></p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('airportId')?.hasError('required') && formGroup.get('airportId')?.touched">
          {{ "airportId" | formErrorMessage : formGroup }}
        </small>
      </div>

      <!-- Ciudad - visible cuando type === 2 -->
      <div
        class="field col-12 md:col-4"
        *ngIf="programType === 2"
      >
        <label style="font-weight: bolder" for="cityId"
          >Ciudad *</label
        >
        <p-dropdown
          id="cityId"
          [options]="cities"
          formControlName="cityId"
          optionValue="id"
          [showClear]="true"
          [filter]="true"
          [style]="{ width: '100%' }"
          optionLabel="name"
          placeholder="Seleccione una ciudad"
        ></p-dropdown>
        <small class="p-error block" *ngIf="formGroup.get('cityId')?.hasError('required') && formGroup.get('cityId')?.touched">
          {{ "cityId" | formErrorMessage : formGroup }}
        </small>
      </div>
    </div>
  </form>
      <!-- Botones de acción -->
    <div class="flex justify-content-end">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="p-fluid formgrid grid">
          <div class="col-6">
            <p-button
              [label]="'DirectSaleFormPage.BackButtonLabel' | translate"
              icon="pi pi-arrow-left"
              (onClick)="onCancelCreation()"
              styleClass="p-button-outlined"
            ></p-button>
          </div>
          <div class="col-6">
            <p-button
              [label]="'DirectSaleFormPage.CreateFromStock' | translate"
              iconPos="right"
              [disabled]="!formGroup.valid || loading"
              [loading]="loading"
              (onClick)="save()"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
 </div>
